<template>
    <div v-if="0 !== relations.length">
        <h2 class="kgr-headline kgr-headline--h3 kgr-headline--text kgr-headline--firstInText">
            {{ headline }}
        </h2>

        <kgr-dog-member-relation-row
            v-for="relation in relations"
            :key="relation.id"
            :is-deletable="isDeletable"
            :relation="relation"
            :pending-remove="pendingRemove"
            @remove="$emit('remove', relation)"
        />
    </div>
</template>

<script>
import DogMemberRelationRow from './DogMemberRelationRow.vue';

export default {
    components: {
        'kgr-dog-member-relation-row': DogMemberRelationRow,
    },
    props: {
        relations: {
            type: Array,
            required: true,
            default: () => {
                return []
            },
        },
        headline: {
            type: String,
            required: true,
        },
        pendingRemove: {
            type: Boolean,
            required: true,
            default: false,
        },
        isDeletable: {
            type: Boolean,
            required: true,
        },
    },
    computed: {
    },
    methods: {
    }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
